import React from 'react'
import { connect } from 'react-redux'
import c from 'classnames'

import Button from 'discada/dist/Button'
import { SimpleTextField } from 'discada/dist/Form'

import { getQueryValue } from 'selectors/pageStateSelectors'
import { exactMatchSearch } from 'actions/inventoryActions'
import { hasWrite } from 'selectors/authSelectors'

export class ExactMatchSearch extends React.Component {
  constructor(...args) {
    super(...args)

    this.state = {
      searchTerm: this.props.searchTerm || '',
    }

    this.set = ({ target }) => this.setState({ searchTerm: target.value })
  }

  render() {
    let { exactMatchSearch, canSearchCustomer } = this.props,
      { searchTerm } = this.state,
      placeholder = canSearchCustomer
        ? 'Search by Stock Number, VIN, or Customer'
        : 'Search Inventory by Stock Number or VIN'

    return (
      <div
        className={c('inventory-filter-controls', 'inventory-filter-search')}
      >
        <SimpleTextField
          size="small"
          value={searchTerm}
          onChange={this.set}
          onKeyPress={e => e.key === 'Enter' && exactMatchSearch(searchTerm)}
          placeholder={placeholder}
        />
        <Button
          icon="search"
          size="small"
          onClick={() => exactMatchSearch(searchTerm)}
        />
      </div>
    )
  }
}

function mapStateToProps(state, op) {
  return {
    searchTerm: getQueryValue(state, 'search.term', ''),
    canSearchCustomer: hasWrite(state, 'rooftop.config/quote'),
  }
}

export default connect(
  mapStateToProps,
  { exactMatchSearch },
)(ExactMatchSearch)
